/**
 * @fileoverview TemplateAddCategory - Form for adding categories to budget template.
 *
 * Provides a dropdown selector to add existing categories to the budget template.
 * The form includes category selection dropdown with proper labels and action buttons.
 * Matches the styling and layout of CategoryAddForm for consistency.
 *
 * @module components/BudgetTemplate/TemplateAddCategory
 */
import styles from './TemplateAddCategory.module.css';

/**
 * TemplateAddCategory Component
 *
 * Form for adding a category to the budget template
 *
 * @param {Object} props - Component props
 * @param {boolean} props.showAddForm - Whether to show the form
 * @param {Function} props.setShowAddForm - Toggle form visibility
 * @param {Array} props.availableCategories - Categories not yet in template
 * @param {string} props.selectedCategory - Currently selected category
 * @param {Function} props.setSelectedCategory - Set selected category
 * @param {Function} props.handleAddCategory - Add category to template
 * @param {Function} props.setError - Set error message
 * @param {boolean} props.readOnly - Whether in read-only mode
 */
function TemplateAddCategory({
    showAddForm,
    setShowAddForm,
    availableCategories,
    selectedCategory,
    setSelectedCategory,
    handleAddCategory,
    setError,
    readOnly
}) {
    if (readOnly) return null;

    return (
        <div className={styles.container}>
            {!showAddForm ? (
                <button
                    onClick={() => setShowAddForm(true)}
                    disabled={availableCategories.length === 0}
                    className={styles.addButton}
                >
                    Add Category to Template
                </button>
            ) : (
                <div className={styles.formCard}>
                    <h4 className={styles.formTitle}>Add Category to Template</h4>
                    <div className={styles.formControls}>
                        <div className={styles.selectWrapper}>
                            <label className={styles.label}>
                                Select Category:
                            </label>
                            <select
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                                className={styles.select}
                            >
                                <option value="">-- Select Category --</option>
                                {availableCategories.map(cat => (
                                    <option key={cat.categoryKey} value={cat.categoryName}>
                                        {cat.categoryName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.buttonGroup}>
                            <button onClick={handleAddCategory} className={styles.submitButton}>
                                Add to Template
                            </button>
                            <button
                                onClick={() => {
                                    setShowAddForm(false);
                                    setSelectedCategory('');
                                    setError('');
                                }}
                                className={styles.cancelButton}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TemplateAddCategory;
